<template>
  <div class="leak-source-table-cell">
    <general-icon v-if="isWebsite" class="leak-source-table-cell__icon" />
    <img v-else :src="icon" alt="" class="leak-source-table-cell__icon" />
    <span class='leak-source-table-cell__source-name'> {{ source }} </span>
  </div>
</template>

<script>
import { leaksDataSources } from '@/constants/leaksData';
import githubIcon from '@/assets/icons/systems/Github.svg';
import pastebinIcon from '@/assets/icons/systems/pastebin.svg';
import GeneralIcon from '@/assets/icons/systems/general.svg?inline';

export default {
  name: 'LeakSourceTableCell',
  components: { GeneralIcon },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    source() {
      if (this.item[this.column.field] === leaksDataSources.github) {
        return this.$t('leaks.tab.source.github');
      }
      if (this.item[this.column.field] === leaksDataSources.pastebin) {
        return this.$t('leaks.tab.source.pastebin');
      }
      return this.$t('leaks.tab.source.websites');
    },
    isWebsite() {
      const src = this.item[this.column.field];
      return src !== leaksDataSources.github &&
        src !== leaksDataSources.gist &&
        src !== leaksDataSources.pastebin;
    },
    icon() {
      const src = this.item[this.column.field];
      if (src === leaksDataSources.github || src === leaksDataSources.gist) {
        return githubIcon;
      }
      return pastebinIcon;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';
.leak-source-table-cell {
  &__icon {
    width: rem(20);
    height: rem(20);
    margin-right: rem(15);
    // inline SVG inherits color for currentColor fill
    color: var(--text-primary);
  }
}

html[data-theme="dark"] img.leak-source-table-cell__icon {
  filter: invert(1);
}
</style>
<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.leak-source-table-cell {
  display: flex;
  &__source-name {
    color: var(--text-primary);
    font-family: $font-family-semibold;
    font-size: rem(14);
    font-weight: 600;
    letter-spacing: 0;
  }
}
</style>
